import React, { Component } from 'react';

import IconButton from '../icon-button/icon-button.jsx';

import './_download-menu.scss';

function DownloadMenuItem({ label, href, onClick, pending }) {
  const spinner = pending ? <i className="download-menu__loader" /> : null;

  if (href) {
    return (
      <a className="download-menu__item" href={href} download onClick={onClick}>
        <span>{label}</span>
        {spinner}
      </a>
    );
  }

  return (
    <button type="button" className="download-menu__item" disabled={pending} onClick={onClick}>
      <span>{label}</span>
      {spinner}
    </button>
  );
}

export default class DownloadMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
    document.addEventListener('touchstart', this.handleDocumentMouseDown);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
    document.removeEventListener('touchstart', this.handleDocumentMouseDown);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleToggle = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
    }
  };

  handleDocumentMouseDown = (event) => {
    if (!this.base || !this.base.contains(event.target)) {
      this.handleClose();
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.handleClose();
    }
  };

  render(props, state) {
    const {
      imageStatus,
      dataStatus,
      dataHref,
      onDownloadData,
      onDownloadImage,
      onDownloadPlainImage,
      onDownloadPlainSvg,
    } = props;
    const imagePending = imageStatus === 'pending';
    const dataPending = dataStatus === 'pending';
    const hasData = !!dataHref || !!onDownloadData;

    return (
      <div className="download-menu">
        <IconButton
          kind="rounded"
          // Spinner on the toggle while any download is in flight, so the status is
          // visible even after the menu is dismissed
          icon={imagePending || dataPending ? 'loader' : 'download'}
          ariaExpanded={state.open}
          ariaLabel="Download"
          handleClick={this.handleToggle}
        />
        {state.open ? (
          <div className="download-menu__popover">
            {hasData ? (
              <DownloadMenuItem
                label="Download data"
                href={dataHref}
                // A static file downloads instantly, so dismiss the menu; an async
                // job stays open to show its spinner
                onClick={dataHref ? this.handleClose : onDownloadData}
                pending={dataPending}
              />
            ) : null}
            <DownloadMenuItem
              label="Download image"
              onClick={onDownloadImage}
              pending={imagePending}
            />
            {onDownloadPlainImage ? (
              <DownloadMenuItem
                label="Download plain image"
                onClick={onDownloadPlainImage}
                pending={imagePending}
              />
            ) : null}
            {onDownloadPlainSvg ? (
              <DownloadMenuItem
                label="Download plain SVG"
                onClick={onDownloadPlainSvg}
                pending={imagePending}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}
